'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _elementType = require('react-prop-types/lib/elementType');

var _elementType2 = _interopRequireDefault(_elementType);

var _bootstrapUtils = require('../utils/bootstrapUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var animationPropType = _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]);

var TabContent = function (_React$Component) {
  _inherits(TabContent, _React$Component);

  function TabContent() {
    _classCallCheck(this, TabContent);

    var _this = _possibleConstructorReturn(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).call(this));

    _this.state = {
      exitingPane: null
    };
    _this.handlePaneExited = _this.handlePaneExited.bind(_this);
    _this.registerPane = _this.registerPane.bind(_this);
    _this.getActiveKey = _this.getActiveKey.bind(_this);
    _this.getContext = _this.getContext.bind(_this);
    return _this;
  }

  _createClass(TabContent, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var exitingPane = this._exitingPane;

      return {
        $bs_tabcontent: {
          bsClass: this.props.bsClass,
          animation: this.props.animation,
          activeKey: exitingPane ? undefined : this.getActiveKey(),
          onExited: this.handlePaneExited,
          register: this.registerPane,
          unmountOnExit: this.props.unmountOnExit
        }
      };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.panes = [];
    }

    /**
     * This belongs in `componentWillReceiveProps()` but
     * 0.14.x contains a bug where cwrp isn't called when only context changes.
     * fixed in master, not sure it will make it into any 0.14 release
     */

  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, _, nextContext) {
      var currentActiveKey = this.getActiveKey();
      var nextActiveKey = this.getActiveKey(nextContext);
      var currentKeyIsStillValid = this.panes.indexOf(currentActiveKey) !== -1;

      if (this.panes.indexOf(this._exitingPane) === -1) {
        this._exitingPane = null;
      }

      if (nextActiveKey !== currentActiveKey && currentKeyIsStillValid) {
        this._exitingPane = currentActiveKey;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children;

      var Component = this.props.componentClass;

      var contentClass = (0, _bootstrapUtils.prefix)(this.props, 'content');

      return _react2.default.createElement(
        Component,
        { className: (0, _classnames2.default)(contentClass, className) },
        children
      );
    }
  }, {
    key: 'handlePaneExited',
    value: function handlePaneExited() {
      this._exitingPane = null;
      this.forceUpdate();
    }

    /**
     * This is unfortunately neccessary because the TabContent needs to know if
     * a TabPane is ever going to exit, since it may unmount and just leave the
     * TabContent to wait longingly forever for the handlePaneExited to be called.
     */

  }, {
    key: 'registerPane',
    value: function registerPane(eventKey) {
      var _this2 = this;

      var panes = this.panes;

      (0, _invariant2.default)(panes.indexOf(eventKey) === -1, 'You cannot have multiple TabPanes of with the same `eventKey` in the same ' + 'TabContent component. Duplicate eventKey: ' + eventKey);

      panes.push(eventKey);

      return function () {
        panes.splice(panes.indexOf(eventKey), 1);

        // #1892
        // new active state can propagate down _before_
        // the tab actually unmounts, so it will map be exiting.
        // since an exiting tab won't complete, clear the bad state
        if (eventKey === _this2._exitingPane) {
          _this2.handlePaneExited();
        }

        // If the tab was active, we need to tell the container
        // that it no longer exists and as such is not active.
        if (eventKey === _this2.getActiveKey()) {
          _this2.getContext('$bs_tabcontainer').onSelect();
        }
      };
    }
  }, {
    key: 'getActiveKey',
    value: function getActiveKey() {
      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.context;

      return this.getContext('$bs_tabcontainer', context).activeKey;
    }
  }, {
    key: 'getContext',
    value: function getContext(key) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;

      return context[key] || {};
    }
  }]);

  return TabContent;
}(_react2.default.Component);

TabContent.defaultProps = {
  componentClass: 'div',
  animation: true,
  unmountOnExit: false
};

TabContent.contextTypes = {
  $bs_tabcontainer: _propTypes2.default.shape({
    activeKey: _propTypes2.default.any,
    onSelect: _propTypes2.default.func
  })
};

TabContent.childContextTypes = {
  $bs_tabcontent: _propTypes2.default.shape({
    bsClass: _propTypes2.default.string,
    animation: animationPropType,
    activeKey: _propTypes2.default.any,
    onExited: _propTypes2.default.func,
    register: _propTypes2.default.func,
    unmountOnExit: _propTypes2.default.bool
  })
};

TabContent.propTypes = {

  /**
   * the Component used to render the TabContent
   */
  componentClass: _elementType2.default,

  /**
   * Sets a default animation strategy for all children TabPanes.
   * Use `false` to disable, `true` to enable the default "Fade"
   * animation or any `<Transition>` component.
   */
  animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),

  /**
   * Unmount the tab (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: _propTypes2.default.bool
};

exports.default = (0, _bootstrapUtils.bsClass)('tab', TabContent);